<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    class="svg-icon icon-to-windowed"
    width="20"
    height="20"
  >
    <path
      fill="currentColor"
      d="M604.842667 480.128h186.496a30.976 30.976 0 1 0 0-61.866667l-142.378667 0.170667 195.285333-194.944a30.890667 30.890667 0 0 0 0-43.776 31.018667 31.018667 0 0 0-43.818666 0l-195.328 194.986667V232.362667a30.976 30.976 0 0 0-61.994667 0v186.154666a61.781333 61.781333 0 0 0 61.738667 61.653334zM223.573333 842.581333l195.328-194.986666v142.378666a30.976 30.976 0 0 0 61.994667 0v-186.154666a61.781333 61.781333 0 0 0-61.738667-61.653334H232.661333a30.976 30.976 0 1 0 0 61.866667l142.378667-0.170667-195.285333 194.986667a30.890667 30.890667 0 0 0 0 43.733333 31.018667 31.018667 0 0 0 43.818666 0z"
    ></path>
  </svg>
</template>

<script>
/**
 * 评论框恢复正常大小用箭头图标
 */
export default {
  name: 'SvgToWindowed',
};
</script>

<style></style>
